module.exports = __webpack_public_path__ + "img/kv.05e9664c.jpg";